var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"inset-0 fixed bg-primary-400 z-100 flex items-center justify-center h-screen md:ml-0 md:min-h-screen"},[_c('Lynx-Spinner',{attrs:{"color":"white","size":"16"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }